import { AppBox, AppGridBox, AppSkeletonBasicInfo, AppTitle, InfoCard } from "../../../../commons/components";
import { useAppSelector } from "../../../../hooks/app";
import { StatusEnum } from "../../../../commons/enums/status-enum";
import { IFootballOrganizer } from "../../../../commons/models/football/interface/i-football-organizer";
import { getCountryName } from "../../../../commons/utilities/country-utils";

interface StadiumInfoProps {
  footballOrganizerInfo: IFootballOrganizer;
}

export default function StadiumInfo({ footballOrganizerInfo }: StadiumInfoProps) {
  const { footballOrganizerInfoStatus } = useAppSelector((state) => state.manageFootballOrganizer);
  const basicInfo = [
    {
      title: footballOrganizerInfo.email ?? "-",
      label: "Contact email",
    },
    {
      title: footballOrganizerInfo.website ?? "-",
      label: "Website",
    },
    {
      title: footballOrganizerInfo.country ? getCountryName(footballOrganizerInfo.country) : "-",
      label: "Country",
    },
  ];

  return (
    <>
      {footballOrganizerInfoStatus === StatusEnum.Loading ? (
        <AppSkeletonBasicInfo />
      ) : (
        <AppBox flexDirection="column" gap="xs">
          <AppTitle as="h5">Basic Information</AppTitle>
          <AppBox flexDirection="column" gap="sm">
            <AppGridBox columns={4} gap="sm">
              {basicInfo.map((item) => (
                <InfoCard key={item.label} alignItems="start" shadow="xs" title={item.title} label={item.label} />
              ))}
            </AppGridBox>
          </AppBox>
        </AppBox>
      )}
    </>
  );
}
